import { Controller } from "../../lib/stimulus-shim"

export default class extends Controller {
  static targets = ["modal", "image", "caption", "counter"]
  static values = { index: { type: Number, default: 0 } }

  connect() {
    this.items = JSON.parse(this.element.dataset.lightboxItems || "[]")
    this._onKeydown = this.handleKeydown.bind(this)
  }

  open(event) {
    event.preventDefault()
    const index = parseInt(event.currentTarget.dataset.lightboxIndex, 10) || 0
    this.indexValue = index
    this.updateDisplay()
    this.modalTarget.showModal()
    document.addEventListener("keydown", this._onKeydown)
  }

  close() {
    this.modalTarget.close()
    document.removeEventListener("keydown", this._onKeydown)
  }

  prev() {
    this.indexValue = (this.indexValue - 1 + this.items.length) % this.items.length
    this.updateDisplay()
  }

  next() {
    this.indexValue = (this.indexValue + 1) % this.items.length
    this.updateDisplay()
  }

  handleKeydown(event) {
    if (event.key === "ArrowLeft") this.prev()
    else if (event.key === "ArrowRight") this.next()
    else if (event.key === "Escape") this.close()
  }

  // Swipe mobile
  touchStart(event) {
    this._touchStartX = event.touches[0].clientX
  }

  touchEnd(event) {
    if (!this._touchStartX) return
    const diff = event.changedTouches[0].clientX - this._touchStartX
    if (Math.abs(diff) > 50) {
      diff > 0 ? this.prev() : this.next()
    }
    this._touchStartX = null
  }

  updateDisplay() {
    const item = this.items[this.indexValue]
    if (!item) return

    this.imageTarget.src = item.url
    this.imageTarget.alt = item.title || ""

    if (this.hasCaptionTarget) {
      this.captionTarget.textContent = item.caption || ""
      this.captionTarget.classList.toggle("hidden", !item.caption)
    }

    if (this.hasCounterTarget) {
      this.counterTarget.textContent = `${this.indexValue + 1}/${this.items.length}`
    }
  }

  // Fermer au clic sur le backdrop
  backdropClick(event) {
    if (event.target === this.modalTarget) this.close()
  }
}
